<template>
  <div class="api-auth">
    <navigation>资料补充</navigation>
    <!-- ocr -->
    <ocr v-if="showOcr" :status="ocrStatus" ref="ocrRef"></ocr>
    <!-- 基本信息 -->
    <section class="title">
      <h1>基本信息</h1>
    </section>
    <main>
      <!-- 表单 -->
      <form
        ref="form"
        class="form"
      >
        <div class="card-panel">
          <div  class="form-item underline-un-focus"> 
            <nd-address
              name="address"
              v-model="form.addressArr"
              :columns="3"
              :mutilple="true"
              inputStyle="width: 70%;margin-left: 30%"
              label="现居住地所在区"
            >
            </nd-address>
          </div>
          <div  class="form-item underline-un-focus textarea">
            <nd-input
              type="textarea"
              name="addressDetail"
              :autoSize="false"
              :rows="1"
              v-model="form.address"
              text-align="right"
              placeholder="详细地址：如小区、楼栋号、单元等"
            >
            </nd-input>
          </div>
        </div>
      </form>
      <!-- 因为交互不统一 产品要求很妖艳儿 所以一个一个写吧 -->
      <div class="select-container">

        <!-- 信用情况 --> 
        <select-item :item="creditStatusStrat" @on-set="setValue" :item-key="form[creditStatusStrat.key]"></select-item>

        <!-- 本地社保 --> 
        <select-item :item="localSocialInsuranceStrat" @on-set="setValue" :item-key="form[localSocialInsuranceStrat.key]"></select-item>

        <!-- 企业主信息 --> 
        <select-item :item="isBusinessOwnerStrat" @on-set="setValue" :item-key="form[isBusinessOwnerStrat.key]"></select-item>

        <!-- 纳税信息 --> 
        <select-item :item="isPayingTaxStrat" @on-set="setValue" :item-key="form[isPayingTaxStrat.key]"></select-item>

        <!-- 房产信息 --> 
        <select-item :item="housePropertyStrat" @on-set="setValue" :item-key="form[housePropertyStrat.key]"></select-item>

        <!-- 车辆信息 -->
        <select-item :item="carStatusStrat" @on-set="setValue" :item-key="form[carStatusStrat.key]"></select-item>

        <select-item v-if="[1,2].includes(form[carStatusStrat.key])" :item="carValueStrat" @on-set="setValue" :item-key="form[carValueStrat.key]"></select-item>

        <select-item v-if="[1,2].includes(form[carStatusStrat.key])" :item="carAgeStrat" @on-set="setValue" :item-key="form[carAgeStrat.key]"></select-item>

        <!-- 打卡工资 -->
        <select-item  :item="salaryByBankStrat" @on-set="setValue" :item-key="form[salaryByBankStrat.key]"></select-item>

        <div class="item" >
          <div class="input-container" v-if="form[salaryByBankStrat.key]===1">
            <div class="input-item" >
              <div class="label">打卡工资金额</div>
              <div class="input-detail">
                <nd-input type="number" v-model="form['salaryByBankAmountStrat']" class="input" :placeholder="salaryByBankAmountStrat.placeHolder"></nd-input>
              </div>
            </div>
          </div>
        </div>

        <!-- 公积金 -->
        <select-item  :item="localHousingFundStrat" @on-set="setValue" :item-key="form[localHousingFundStrat.key]"></select-item>
        <div class="item" >
          <div class="input-container" v-if="form[localHousingFundStrat.key]===1">
            <div class="input-item" >
              <div class="label">公积金缴纳金额金额</div>
              <div class="input-detail">
                <nd-input type="number" v-model="form['localHousingFundAmountStrat']" class="input" :placeholder="localHousingFundAmountStrat.placeHolder"></nd-input>
              </div>
            </div>
          </div>
        </div>
        
        <!-- 保单信息 -->
        <select-item  :item="businessInsuranceStrat" @on-set="setValue" :item-key="form[businessInsuranceStrat.key]"></select-item>
        <!-- 保单缴纳时间 -->
        <select-item  :item="durationOfInsuranceStrat" v-if="[1,2].includes(form[businessInsuranceStrat.key])" @on-set="setValue" :item-key="form[durationOfInsuranceStrat.key]"></select-item>

        <div class="item" >
          <div class="input-container"  >
            <div class="input-item" >
              <div class="label">申请额度</div>
              <div class="input-detail">
                <nd-input type="number" v-model="form['applyLimitStrat']" class="input" :placeholder="applyLimitStrat.placeHolder"></nd-input>
              </div>
            </div>
          </div>
        </div>
 
      </div>
    </main>
    <footer class="footer">
      <nd-button class="btn" @click="check" :loading="loading">提交资料，立获额度</nd-button>
      <p class="xie-yi">请在点击「提交资料，立获额度」前，仔细阅读 <a @click="toProtocol360">《融360个人信息授权书》</a><a @click="toProtocol">《个人信息使用授权书》</a> </p>
    </footer>

    <detention-dialog
      v-model="detentionVisible"
      @on-close="detentionVisible=false"
    />

    <!-- <nd-dialog v-model="authenticationVisible" class="auth-dialog" :footer="false" :closeBtn="true" >
      <div class="default-content">
        <iframe ref="authIframe" @load="IframeLoaded" class="iframe" :src="`${origin}/protocol/tmdr360?hideTitle=Y`"  frameborder="0"></iframe>
      </div>
      <div class="btn-wrapper">
        <nd-button class="btn" @click="submitBaseInfo">我已完成阅读并同意上述协议</nd-button>
    
      </div>
    </nd-dialog> -->

    <van-popup
      v-model="authenticationVisible"
      round
      position="bottom"
      class="api-popup"
    >
      <div class="api-popup-top">
        <span class="cancle" @click="authenticationVisible=false">取消</span>
      </div>
      <div class="api-popup-main">
        <iframe ref="authIframe" @load="IframeLoaded" class="iframe" :src="`${origin}/protocol/tmdr360?hideTitle=Y`"  frameborder="0"></iframe>
      </div>
      <div class="api-popup-foot">
        <nd-button class="popup-foot-btn" @click="submitBaseInfo" :loading="loading">确认</nd-button>
      </div>
    </van-popup>
  </div>
</template>

<script>
import { mapActions } from 'vuex'
import validateNew from '@/components/nd-validate/validateNew'
import { getKey } from '@/assets/utils'
import { setKey } from '../../../assets/utils'

export default {
  name: 'apiAuth',
  mixins: [validateNew],
  components: {
    detentionDialog: () => import('./components/detention-dialog.vue'),
    ocr: () => import('./components/ocr.vue'),
    selectItem: () => import('./components/select-item.vue')
  },
  data () {
    return {
      loading: false,
      detentionVisible: false, 
      allData: [],
      origin: window.location.origin,
      productDetail: {},
      authenticationVisible: false,
      form: {
        addressArr: '',
        creditStatusStrat: '',
        localSocialInsuranceStrat: '',
        isBusinessOwnerStrat: '',
        isPayingTaxStrat: '',
        address: '',
        housePropertyStrat: '',
        carStatusStrat: '',
        carValueStrat: '',
        carAgeStrat: '',
        salaryByBankStrat: '',
        salaryByBankAmountStrat: '',
        localHousingFundStrat: '',
        localHousingFundAmountStrat: '',
        businessInsuranceStrat: '',
        durationOfInsuranceStrat: '',
        applyLimitStrat: ''
      },
      creditStatusStrat: { 
        label: '信用情况',
        key: 'creditStatusStrat',
        visible: false,
        values: [
          { displayName: '无信用卡或贷款', value: 0 },
          { displayName: '信用良好无预期', value: 1 },
          { displayName: '1年内逾期少于3次且少于90天', value: 2 },
          { displayName: '1年内逾期超过3次或超过90天', value: 3 }
      ] },
      localSocialInsuranceStrat: { 
        label: '本地社保',
        key: 'localSocialInsuranceStrat',
        visible: false,
        values: [
          { displayName: '无本地社保', value: 0 },
          { displayName: '有本地社保', value: 1 }
      ] },
      isBusinessOwnerStrat: { 
        label: '企业主信息',
        key: 'isBusinessOwnerStrat',
        visible: false,
        values: [
          { displayName: '不是企业主', value: 0 },
          { displayName: '是企业主，有营业执照', value: 1 },
          { displayName: '是企业主，没有营业执照', value: 2 }
      ] },
      isPayingTaxStrat: { 
        label: '纳税信息',
        key: 'isPayingTaxStrat',
        visible: false,
        values: [
          { displayName: '未交税', value: 0 },
          { displayName: '正常缴税', value: 1 }
      ] },
      housePropertyStrat: { 
        label: '房产信息',
        key: 'housePropertyStrat',
        visible: false,
        values: [
          { displayName: '无房产', value: 0 },
          { displayName: '全款商品房或商铺', value: 1 },
          { displayName: '按揭或抵押房', value: 2 },
          { displayName: '自建或小产权', value: 3 }
      ] },
      carStatusStrat: { 
        label: '车辆信息',
        key: 'carStatusStrat',
        showChildren: false,
        visible: false,
        values: [
          { displayName: '无车辆', value: 0 },
          { displayName: '非运营可抵押车', value: 1 },
          { displayName: '不可抵押车', value: 2 }
      ] },

      carValueStrat: { 
        label: '车辆价值',
        key: 'carValueStrat',
            
        visible: false,
        values: [
          { displayName: '车辆估值大于10万', value: 1 },
          { displayName: '车辆估值小于10万', value: 2 }
      ] },
      carAgeStrat: { 
        label: '车龄情况',
        key: 'carAgeStrat',
         
        visible: false,
        values: [
          { displayName: '车龄大于8年', value: 0 },
          { displayName: '车龄小于8年', value: 1 }
      ] },
      salaryByBankStrat: {
        label: '打卡工资',
        key: 'salaryByBankStrat',
          
        visible: false,
        values: [
          { displayName: '无打卡工资', value: 0 },
          { displayName: '有打卡工资', value: 1 }
        ]
      },
      salaryByBankAmountStrat: {
        displayName: '打卡工资金额', key: 'salaryByBankAmountStrat', placeHolder: '单位：元' 
      },
      localHousingFundStrat: {
        label: '公积金',
        key: 'localHousingFundStrat',
        visible: false,
        values: [
          { displayName: '无本地公积金', value: 0 },
          { displayName: '有本地公积金', value: 1 }
        ]
      },
      localHousingFundAmountStrat: {
        displayName: '公积金缴纳金额金额', key: 'localHousingFundAmountStrat', placeHolder: '单位：元'
      },
      businessInsuranceStrat: {
        label: '保单信息',
        key: 'businessInsuranceStrat',
        visible: false,
        values: [
          { displayName: '无保单', value: 0 },
          { displayName: '有寿险或年金险', value: 1 },
          { displayName: '其他保单', value: 2 }
        ] 
      },
      durationOfInsuranceStrat: { 
        label: '保单缴纳时间',
        key: 'durationOfInsuranceStrat',
        visible: false,
        values: [
          { displayName: '缴纳未满1年', value: 0 },
          { displayName: '缴纳1年以上', value: 1 }
        ]
      },
      applyLimitStrat: {
        displayName: '申请额度', key: 'applyLimitStrat', placeHolder: '单位：元' 
      },
      rules: {},
      baseInfo: {
        ocrRecord: {},
        authStatus: []
      },
      orcConfig: [],
      dict: {},
      stepType: 'ALL'
    }
  },
  async mounted () {
    this.stepType = this.$route.query.stepType || 'ALL'
    // this.getPrInfo()

    try {
      const configIds = getKey('configIds')
      this.init(configIds)
      this.getUserInfo()
      this.$bus.$emit('ready')
    } catch (e) {
      this.$bus.$emit('ready')
    }
  },
  watch: {
    'form.carStatusStrat' (val, old) {
      if (old) {
        this.form.carValueStrat = ''
        this.form.carAgeStrat = ''
      }
    },
    'form.businessInsuranceStrat' (val, old) {
      if (old) {
        this.form.durationOfInsuranceStrat = ''
      }
    }
  },
  computed: {
    ocrStatus () {
      if (this.baseInfo.authStatus.includes('OCR_EXPIRE')) {
        return 'expired'
      } else {
        return 'ocr'
      }
    },
    showOcr () {
      return !this.baseInfo.authStatus.includes('OCR') || this.baseInfo.authStatus.includes('OCR_EXPIRE')
    }
  },
  methods: {
    ...mapActions('apiDiversion', ['getProductInfo', 'userBaseInfo', 'formCommit', 'formBaseInfo']),
    ...mapActions('user', ['protocolShow']),
    toProtocol360 () {
      setKey('r360-form', this.form)
      this.$router.push('/protocol/r-360/null')
    },
    toProtocol () {
      setKey('r360-form', this.form)
      this.$router.push('/protocol/tmdr360')
    },
    IframeLoaded () {
      this.$nextTick(() => {
        this.$refs['authIframe'].contentWindow.postMessage({
          type: 'setFontSize',
          value: document.documentElement.style.fontSize
        }, '*')
      })
    },
    async getPrInfo () {
      const { success, data } = await this.getProductInfo({ configId: getKey('configIds')[0], productInfo: true }) 
      if (success) {
        this.productDetail = data || {}
      }
    },
    showSelect (item) {
      item.visible = true
      item.showChildren = true
      // this.$forceUpdate()
    },
    setValue (item) {
      const { key, value } = item
      this.form[key] = value
      // item.visible = false
      // this.$forceUpdate()
    },
    renderTxt (key, values) {
      if (key || key === 0) {
        return values.find(item => item.value === key).displayName
      }
    },
    showCase (item, index) {
      const { key } = item
      if (['carValueStrat', 'carAgeStrat'].includes(key)) {
        return false
      }
      return false
    },
   
    async init (configIds) {
      if (this.stepType === 'OCR') return
 
      this.$nextTick(() => {
        this.validator(this.$refs.form, this.rules)
      })
    },
    async getUserInfo () {
      const stashData = getKey('r360-form') || {}
     
      const [formBaseInfo, userBaseInfo] = await Promise.all([this.formBaseInfo(), this.userBaseInfo({ queryType: 'detail' })])
      if (formBaseInfo.success && userBaseInfo.success) {
        this.baseInfo = userBaseInfo.data
        const { address, area, areaCode, city, cityCode, province, provinceCode } = userBaseInfo.data.userDetail || {}
        this.form = { ...this.form, ...formBaseInfo.data, ...userBaseInfo.data.userDetail } 
        this.form.addressArr = [province, city, area, provinceCode, cityCode, areaCode].join(' ')
        this.form.address = address
      }
      Object.keys(this.form).forEach(key => {
        if (!this.form[key] && (stashData[key] || stashData[key] === 0)) {
          this.form[key] = stashData[key]
        }
      })
    },
    hasKey (key) {
      return key || key === 0
    },
    async check () {
      if (!this.form.addressArr.replace(/(^\s*)/g, '')) { 
        return this.$message('请完善现居住地所在区') 
      }
      if (this.form.addressArr.length && this.form.addressArr.split(' ').length < 6) {
        return this.$message('请重新选择现居住地所在区') 
      }
      if (!this.form.address) return this.$message('请完善现居住地所在区')
      if (!this.hasKey(this.form.creditStatusStrat)) return this.$message('请完善信用情况')
      if (!this.hasKey(this.form.localSocialInsuranceStrat)) return this.$message('请完善本地社保产信息')

      if (!this.hasKey(this.form.isBusinessOwnerStrat)) return this.$message('请完善企业主信息')
      if (!this.hasKey(this.form.isPayingTaxStrat)) return this.$message('请完纳税信息')

      if (!this.hasKey(this.form.housePropertyStrat)) return this.$message('请完善房产信息')


      if (!this.hasKey(this.form.carStatusStrat)) return this.$message('请完善车辆信息')
      if (this.form.carStatusStrat) {
        if (!this.hasKey(this.form.carValueStrat)) return this.$message('请完善车辆价值信息')
        if (!this.hasKey(this.form.carAgeStrat)) return this.$message('请完善车辆车龄情况')
      }

      if (!this.hasKey(this.form.salaryByBankStrat)) return this.$message('请完善打卡工资')
      if (this.form.salaryByBankStrat && !this.hasKey(this.form.salaryByBankAmountStrat)) return this.$message('请完善打卡工资金额')

      if (this.hasKey(this.form.salaryByBankAmountStrat) && !/^\d+$/.test(this.form.salaryByBankAmountStrat)) return this.$message('打卡工资金额为整数')

      if (!this.hasKey(this.form.localHousingFundStrat)) return this.$message('请完善公积金')
      if (this.form.localHousingFundStrat && !this.hasKey(this.form.localHousingFundAmountStrat)) return this.$message('请完善公积金缴纳金额')

      if (this.hasKey(this.form.localHousingFundAmountStrat) && !/^\d+$/.test(this.form.localHousingFundAmountStrat)) return this.$message('公积金缴纳金额为整数')

      if (!this.hasKey(this.form.businessInsuranceStrat)) return this.$message('请完善保单信息')
      if (this.form.businessInsuranceStrat && !this.hasKey(this.form.durationOfInsuranceStrat)) return this.$message('请完善保单缴纳时间')

      if (!this.hasKey(this.form.applyLimitStrat)) return this.$message('请完善申请额度')

      if (this.hasKey(this.form.applyLimitStrat) && !/^\d+$/.test(this.form.applyLimitStrat)) return this.$message('申请额度为整数')
      
     
      this.loading = true
      const res = await this.protocolShow()
      this.loading = false
      if (res.success && res.data && res.data.show) {
        this.authenticationVisible = true 
      } else {
        this.submitBaseInfo()
      }
    },
    // 提交资料
    async submitBaseInfo () {
      const [province, city, area, provinceCode, cityCode, areaCode] = this.form.addressArr.split(' ')
      const { address } = this.form
   
      try {
        if (this.showOcr) {
          await this.$refs.ocrRef.next()
        }
        const baseInfo = { province, city, area, provinceCode, cityCode, areaCode, address }
        const { success, data } = await this.formCommit({
          baseInfo,
          formDataInfo: {
            ...this.form,
            configId: getKey('configIds')[0]
          }
        })
        if (success) {
          // 准入成功跳转三方结果页、准入失败跳转联登结果-联登失败页面
          if (data.status) {
            window.location.href = data.url
          } else {
            this.$router.replace('/river/result?type=fail&from=r360')
          }
        }
      } catch (error) {
        console.log(error)
      }
    }
  }
}
</script>
<style lang="less" src="./css/popup.less" scoped></style>
@import "../../../assets/less/mixin.less";

<style lang="less" scoped>
@import "../../../assets/less/mixin.less";

.api-auth {
  background: #f7f7f7;
  min-height: 100vh;

  /deep/ .page {
    width: 750px;
 
  }
  .iframe {
      height: 638px;
      width: 100%;

      html {
          width: 100%;
      }
  }
  .btn-wrapper {
    position: fixed;
    background: white;
    height: 162px;
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: center;
    width: 620px;
    border-radius: 0 0 30px 30px;
    transform: translateY(-20px);

    .btn {
      width: 500px;
    }
  }
  .title {
    padding: 32px 40px;
    margin-top: 30px;
    h1 {
      font-size: 46px;
      font-family: PingFangSC-Medium, PingFang SC;
      font-weight: 500;
      height: 65px;
      line-height: 65px;
      color: @fc1;
      position: relative;

      img {
        width: 56px;
        position: absolute;
        bottom: 7px;
      }

      span {
        margin-left: 76px;
      }
    }

    h2 {
      margin-top: 17px;
      font-size: 28px;
      line-height: 40px;
      font-family: PingFangSC-Regular, PingFang SC;
      font-weight: 400;
      color: @fc3;
    }
  }
  .select-container {
    padding-top: 20px;
    .item {
      display: flex;
      flex-direction: column;
      .line {
        display: flex;
        font-size: 28px;
        font-family: PingFangSC-Medium, PingFang SC;
        font-weight: 500;
        padding:20px 40px;
        &:before {
          content: '*';
          font-weight: 500;
          color: #DC5050;
        }
        .value {
          flex:1
        }
        .change {
          width: 140px;
          height: 48px;
          background: linear-gradient(90deg, #FF3333 0%, #FF5F34 100%);
          border-radius: 28px;
          font-size: 24px;
        }
      }

      .radios-container{
        display: flex;
        flex-wrap:wrap;
        padding-left:40px;
        .r-item {
          width: 320px;
          height: 72px;
          border-radius: 8px;
          border: 1px solid #FF4633;
          font-family: PingFangSC-Regular, PingFang SC;
          font-weight: 400;
          color: #FF4633;
          display: flex;
          justify-content: center;
          align-items: center;
          font-size: 26px;
          margin-right: 30px;
          margin-bottom: 20px;
          &.active {
            background: #FF4633;
            color: #fff;
          }
        }
      }

      .input-container {
        .input-item {
          padding:20px 40px;
          &:before {
            content: '*';
            font-weight: 500;
            color: #DC5050;
          }
          .label {
            display: inline;
            font-size: 28px;
            font-family: PingFangSC-Medium, PingFang SC;
            font-weight: 500;
          }
          .input-detail {
            width: 670px;
            height: 72px;
            border-radius: 8px;
            border: 1px solid #AAAAAA;
            margin-top: 20px;
            /deep/ .nd-input {
              input{
              padding: 18px  20px;
            }
            } 
          }
        }
      }
    }
  }

  .form {
    .card-title {
      height: 45px;
      line-height: 45px;
      margin: 75px 40px 23px;
      font-size: 32px;
      font-family: PingFangSC-Regular, PingFang SC;
      font-weight: 400;
      color: @fc3;
      position: relative;

      img {
        width: 44px;
        height: 44px;
        position: absolute;
        left: 0;
      }

      span {
        margin-left: 56px;
      }
    }

    .card-panel {
      background-color: white;

      .form-item {
        height: 110px;
        line-height: 110px;
        padding: 0 40px;
        margin-top: 0;
        // .form-tip{
        //     top: 65%;
        // }
        .input-cover {
          position: absolute;
          left: 40px;
          right: 40px;
          z-index: 1;
          height: 100%;
        }

        &.textarea {
          height: 80px;
          .nd-input {
            margin-top: 40px;
            line-height: 1.4em;
          }
        }

        .nd-select,
        .nd-input,
        .nd-choose,
        .nd-address {
          label {
            font-size: 30px;
            font-family: PingFangSC-Regular, PingFang SC;
            font-weight: 400;
          }

          input {
            font-size: 30px;
          }

          textarea {
            font-size: 30px;
          }
        }

        .nd-input {
          .nd-input-inner {
            line-height: 1.4em;
          }
        }
      }
    }
  }

  .main-product {
    width: 690px;
    height: 320px;
    background: #ffffff;
    border-radius: 20px;
    margin: 30px auto;
    padding: 30px;

    .header {
      display: flex;
      height: 90px;
      align-items: center;
      border-bottom: 1px solid #eee;
      img {
        width: 48px;
        height: 48px;
        margin-right: 10px;
      }
      .name {
        font-size: 28px;
        font-family: PingFangSC-Medium, PingFang SC;
        font-weight: 500;
      }
      .info {
        flex: 1;
        font-size: 20px;
        text-align: right;
        .danger {
          color: #ff4633;
        }
      }
    }
    .content {
      display: flex;
      flex-direction: column;
      padding: 10px 0;
      height: 180px;
      justify-content: space-around;
      .name {
        font-size: 24px;
      }
      .amount {
        font-size: 40px;
        font-family: DIN-Medium, DIN;
        font-weight: 500;
      }
      .exp {
        color: #999;
        font-size: 24px;
      }
    }
  }
  .task-list {
    border-radius: 20px;
    overflow: hidden;
    margin: 0 30px;
    .success {
      color: #aaa;
    }
    .wait {
      color: #8eb2d8;
    }
    .nd-cell {
      border-bottom: 1px solid #eee;
    }
  }

  .footer {
    display: flex;
    flex-direction: column;
    padding: 20px 0 40px;
    align-items: center;
    width: 100%;
    background: #fff;
    margin-top: 40px;
    .xie-yi {
      margin-top: 30px;
      color: #999;
      font-size: 24px;
      padding:10px 50px;
      text-align: left;
      a {
        color: #8eb2d8;
      }
    }
  }
}
</style>
